// Curated cinematic Japan imagery (Unsplash). Atmospheric, minimal people.
export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1771893327514-842e33b8bf85?q=80&w=2400&auto=format&fit=crop",
  heroAlt: "https://images.unsplash.com/photo-1528360983277-13d401cdc186?q=80&w=2400&auto=format&fit=crop",
  destinations: {
    tokyo: "https://images.unsplash.com/photo-1759274003856-1ad3e6f63283?q=80&w=2000&auto=format&fit=crop",
    kyoto: "https://images.unsplash.com/photo-1767840272171-9c12ce266646?q=80&w=2000&auto=format&fit=crop",
    osaka: "https://images.unsplash.com/photo-1694932846191-123e747e61b1?q=80&w=2000&auto=format&fit=crop",
    hakone: "https://images.unsplash.com/photo-1699444118039-d9c5288db3ad?q=80&w=2000&auto=format&fit=crop",
    naoshima: "https://images.unsplash.com/photo-1747747005816-877450afb16f?q=80&w=2000&auto=format&fit=crop",
  },
  experiences: {
    culture: "https://customer-assets.emergentagent.com/job_luxury-journeys-jp/artifacts/d7kxggsx_GettyImages-1270033471-1024x600.jpg",
    dining: "https://customer-assets.emergentagent.com/job_luxury-journeys-jp/artifacts/2ulxyzj2_image-60-1024x682.webp",
    modern: "https://images.unsplash.com/photo-1542051841857-5f90071e7989?q=80&w=1800&auto=format&fit=crop",
    relaxation: "https://images.unsplash.com/photo-1540679028-3f7bb9b09aeb?q=80&w=1800&auto=format&fit=crop",
    logistics: "https://images.unsplash.com/photo-1533661775116-69e83a1b8e2a?q=80&w=1800&auto=format&fit=crop",
  },
  founder: "https://images.unsplash.com/photo-1528360983277-13d401cdc186?q=80&w=1800&auto=format&fit=crop",
  planHero: "https://images.unsplash.com/photo-1528164344705-47542687000d?q=80&w=2200&auto=format&fit=crop",
};

export const DESTINATIONS = [
  {
    slug: "tokyo",
    name: "Tokyo",
    tag: "Metropolis",
    short: "Controlled chaos, precisely curated.",
    long:
      "A private Tokyo is quieter than the city suggests. Omakase counters reserved before they open, galleries opened after hours, neighborhoods walked with someone who has lived them for a decade.",
    image: "tokyo",
  },
  {
    slug: "kyoto",
    name: "Kyoto",
    tag: "Tradition",
    short: "Private access to tradition.",
    long:
      "Temples before the gates open. Gardens without the murmur. An introduction to craftspeople whose work rarely leaves their studio. Kyoto is unhurried here.",
    image: "kyoto",
  },
  {
    slug: "osaka",
    name: "Osaka",
    tag: "Appetite",
    short: "Energy, food, and culture — refined.",
    long:
      "Osaka's pace is its pleasure. We pair its spirited street life with precise, chef-led dining and a lighter, unexpected cultural rhythm.",
    image: "osaka",
  },
  {
    slug: "hakone",
    name: "Hakone",
    tag: "Stillness",
    short: "Quiet luxury, framed by nature.",
    long:
      "Mountain ryokan chosen for craft, light, and silence. Onsen at the right hour. Cedar, mist, and a view of Fuji that arrives when it chooses.",
    image: "hakone",
  },
  {
    slug: "naoshima",
    name: "Naoshima",
    tag: "Art & Isolation",
    short: "Art, architecture, and isolation.",
    long:
      "A private ferry, an island shaped by Ando, and museums visited without a crowd. Naoshima rewards travelers who arrive with intention.",
    image: "naoshima",
  },
];

export const EXPERIENCE_GROUPS = [
  {
    slug: "culture",
    title: "Culture",
    image: "culture",
    items: [
      "Private tea ceremony with a master",
      "Temple openings before public hours",
      "Craftspeople introductions (ceramics, lacquer, textiles)",
      "Traditional evenings: geisha, noh, heritage venues",
    ],
  },
  {
    slug: "dining",
    title: "Dining",
    image: "dining",
    items: [
      "Reserved omakase counters and chef-led tastings",
      "Hard-to-reach kaiseki ryokans",
      "Private sake and whisky pairings",
      "Seasonally-led menus designed around your palate",
    ],
  },
  {
    slug: "modern",
    title: "Modern Japan",
    image: "modern",
    items: [
      "Architecture-led itineraries",
      "After-hours gallery and museum access",
      "Contemporary design ateliers",
      "Private meetings with curators and collectors",
    ],
  },
  {
    slug: "relaxation",
    title: "Relaxation",
    image: "relaxation",
    items: [
      "Selected ryokan with private onsen",
      "Forest bathing and quiet garden walks",
      "Wellness-led pacing, unhurried days",
      "In-suite treatments and traditional therapies",
    ],
  },
  {
    slug: "logistics",
    title: "Travel Logistics",
    image: "logistics",
    items: [
      "Private transfers and chauffeured travel",
      "Shinkansen reservations handled discreetly",
      "Bilingual host attending where needed",
      "A single point of contact, always reachable",
    ],
  },
];
